module.exports = __webpack_public_path__ + "img/twitter-color.781a24f9.svg";